<script setup lang="ts">
import { computed } from 'vue'
import { ProgressIndicator, ProgressRoot } from 'reka-ui'

const p = withDefaults(defineProps<{
  value: number; tone?: 'primary' | 'success' | 'warning' | 'danger'; label: string; valueText?: string
}>(), { tone: 'primary' })
const clamped = computed(() => Math.min(100, Math.max(0, p.value)))
const COLOR = { primary: 'bg-primary', success: 'bg-success', warning: 'bg-warning', danger: 'bg-danger' }
</script>

<template>
  <ProgressRoot :model-value="clamped" :aria-label="label" :aria-valuetext="valueText"
                class="relative h-1.5 w-full overflow-hidden rounded-pill bg-muted">
    <!-- Fills from its start when it first shows, then follows its value. -->
    <ProgressIndicator :class="[COLOR[tone], 'h-full origin-left animate-grow-x transition-[width] duration-slow ease-out rtl:origin-right']"
                       :style="{ width: `${clamped}%` }" />
  </ProgressRoot>
</template>
